export const ROUTER_LINKS = {
  accountBookmarks: '/account/bookmarks',
  accountListings: '/account/listings',
  accountPayments: '/account/payments',
  accountPaymentsSuccess: '/account/payments/success',
  accountProfile: '/account/profile',
  accountValidation: '/account/validation',
  accountValidationIdCard: '/account/validation/id-check/id-card',
  accountValidationIdCheck: '/account/validation/id-check',
  accountValidationPassport: '/account/validation/id-check/passport',
  addressCheck: '/account/validation/address-check',
  blog: '/blog',
  downloadApp: '/download-app',
  findingRoom: '/finding-a-room',
  help: '/support',
  home: '/',
  listings: '/listings',
  listingsAdd: '/account/listings/add',
  listingsEdit: '/account/listings/edit',
  login: '/login',
  logout: '/logout',
  megaphone: '/megaphone',
  messages: '/conversations',
  messagesInbox: '/conversations/inbox',
  partner: '/partner',
  phoneAuth: '/phone-auth',
  press: '/press',
  privacy: '/privacy',
  profile: '/profile',
  rentingOutRoom: '/renting-out-a-room',
  reviews: '/reviews',
  settings: '/settings',
  sitemap: '/sitemaps',
  sitemapNeighborhoods: '/sitemaps/neighborhoods',
  support: '/support',
  terms: '/terms',
  topReviews: '/reviews/top-reviews',
} as const;

export const DOWNLOAD_APP_LINKS = {
  appStore: 'https://itunes.apple.com/us/app/roomster-roommate-finder-find/id1045548013',
  googlePlay: 'https://play.google.com/store/apps/details?id=com.roomster',
} as const;

export const SOCIAL_MEDIA_LINKS = {
  facebook: 'https://www.facebook.com/RoomsterCorp',
  instagram: 'https://www.instagram.com/roomster/',
  pinterest: 'https://pinterest.com/roomster/',
  twitter: 'https://x.com/roomster',
  vimeo: 'https://vimeo.com/roomsterroommates',
  youtube: 'https://www.youtube.com/user/roomsterroommates',
} as const;

export const EXTERNAL_LINKS = {
  affiliateProgram: 'https://roomster.com/affiliate',
  fairHousing: 'https://portal.hud.gov/hudportal/HUD?src=/program_offices/fair_housing_equal_opp/FHLaws/yourrights',
  faq: 'https://support.roomster.com',
} as const;
